import React from 'react';
import { InputNumber, Space, Typography } from 'antd';
import { DEFAULT_CLASSIC_MAX_PRIOR_USER_LINES } from './ChatRetrievalStrategySection';

const { Text } = Typography;

/**
 * How many prior **user** lines (before the latest message) feed the standard search string.
 * Same control pattern as rewriter max messages ({@link RagQueryRewriteAdvancedOptions}).
 */
export default function RagClassicPriorLinesField({ value, onChange, disabled }) {
    return (
        <div className="chat-retrieval-classic-prior-field">
            <Space align="center" wrap className="chat-retrieval-classic-prior-row">
                <Text type="secondary" className="chat-retrieval-classic-prior-label">
                    Include up to
                </Text>
                <InputNumber
                    min={1}
                    max={32}
                    value={value}
                    onChange={(v) => onChange(v != null && !Number.isNaN(Number(v)) ? Number(v) : DEFAULT_CLASSIC_MAX_PRIOR_USER_LINES)}
                    disabled={disabled}
                    aria-label="Number of earlier user questions to include in search"
                />
                <Text>prior user questions</Text>
                <Text type="secondary" className="chat-retrieval-classic-prior-hint">
                    (besides the latest message)
                </Text>
            </Space>
        </div>
    );
}
